import BordTableWithActions from 'components/NudosComponents/BordTableWithActions/BordTableWithActions';
import { HISTORY_HEADERS } from '../../constants';
import { useEffect, useMemo, useState } from 'react';
import { getCatalogHistory, getOrdersHistory, getQuotesHistory } from 'services/bulkUpload/bulkUploadHistory.service';
import { BULK_UPLOAD_TYPE_ID, IBulkUploadHistoryItem } from '../../TypeOfCharge.types';
import {
  mapCatalogUploadHistoryData,
  mapOrdersUploadHistoryData,
  mapQuotesUploadHistoryData
} from '../../TypeOfCharge.mapper';
import useUsersState from 'state/useUsersState';
import UserInfo from 'components/UserInfo/UserInfo';
import LoadStatus from '../LoadStatus/LoadStatus';
import HistoryTemplate from '../HistoryTemplate/HistoryTemplate';
import { historyActions } from '../../content/UploadHistoryContent';
import useOnlyDevelopers from 'state/setOnlyDevelopers';
import './UploadHistory.scss';

const UploadHistory = () => {
  const { isOnlyDevsAutomates } = useOnlyDevelopers();
  const [data, setData] = useState<(string | number | React.ReactNode)[][]>([]);
  const [typeOfChargeSelected, setTypeOfChargeSelected] = useState<BULK_UPLOAD_TYPE_ID>(
    isOnlyDevsAutomates ? BULK_UPLOAD_TYPE_ID.QUOTES : BULK_UPLOAD_TYPE_ID.CATALOG
  );
  const { users } = useUsersState();

  const handleTypeOfChargeChange = (value: BULK_UPLOAD_TYPE_ID) => {
    if (!value) return;
    setTypeOfChargeSelected(value);
  };

  const title = useMemo(() => {
    switch (typeOfChargeSelected) {
      case BULK_UPLOAD_TYPE_ID.CATALOG:
        return 'Historial de cargue de catálogo';
      case BULK_UPLOAD_TYPE_ID.ORDERS:
        return 'Historial de cargue de órdenes';
      case BULK_UPLOAD_TYPE_ID.QUOTES:
        return 'Historial de cargue de cotizaciones';
    }
  }, [typeOfChargeSelected]);

  const actions = historyActions({
    actions: [handleTypeOfChargeChange],
    values: [typeOfChargeSelected],
    isOnlyDevsAutomates
  });

  const headers = HISTORY_HEADERS;

  const fetchHistoryData = async () => {
    let formatedData: IBulkUploadHistoryItem[] = [];
    switch (typeOfChargeSelected) {
      case BULK_UPLOAD_TYPE_ID.CATALOG:
        const historyDataCatalog = await getCatalogHistory();
        formatedData = mapCatalogUploadHistoryData(historyDataCatalog, users);
        break;
      case BULK_UPLOAD_TYPE_ID.ORDERS:
        const historyDataOrders = await getOrdersHistory();
        formatedData = mapOrdersUploadHistoryData(historyDataOrders, users);
        break;
      case BULK_UPLOAD_TYPE_ID.QUOTES:
        const historyDataQuotes = await getQuotesHistory();
        formatedData = mapQuotesUploadHistoryData(historyDataQuotes, users);
        break;
    }
    setData(
      formatedData.map((item: IBulkUploadHistoryItem) => [
        item.date,
        item.loadId,
        <UserInfo
          firstName={item.responsible.firstName}
          lastName={item.responsible.lastName}
          email={item.responsible.email}
          profilePhoto={item.responsible.avatar}
        />,
        <LoadStatus {...item.loadStatus} />,
        <HistoryTemplate templateLink={item.template} />
      ])
    );
  };

  useEffect(() => {
    if (users && typeOfChargeSelected) fetchHistoryData();
  }, [users, typeOfChargeSelected]);

  return (
    <section className="uploadHistory">
      <BordTableWithActions
        title={title}
        actions={actions}
        headers={headers}
        data={data}
        className="uploadHistoryWithActions"
        tableClassName="uploadHistoryTable"
      />
    </section>
  );
};

export default UploadHistory;
